import styled from '@emotion/styled';
import { classNames } from '../../services/classNames';

import React from 'react';

interface SimpleTextSectionProps {
    title: string;
    className?: string;
    contentClassName?: string;
}

export const SimpleTitleSection: React.FC<SimpleTextSectionProps> = ({
    className = '',
    contentClassName = '',
    title,
    children,
}) => {
    return (
        <Wrapper className={classNames('SimpleTitleSection', className)}>
            {title && <Title>{title}</Title>}
            {children && (
                <div
                    className={classNames(
                        'SimpleTitleSection__content',
                        contentClassName,
                    )}
                >
                    {children}
                </div>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    padding: 40px 0;
`;

const Title = styled.h2``;
